import { useCallback, useState } from 'react';
import { List } from 'foundations-components/transitional/components/List';
import { usageTracker } from '../usage-tracker/usageTracker';
import { getUsageTrackingChannel } from '../usage-tracker/trackerChannelIdMapping';
import MessageActionsButton from './MessageActionsButton';
import I18n from 'I18n';
import { VerticalMenuIcon } from 'foundations-assets';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const MessageActionsDropdown = ({
  children,
  genericChannelId
}) => {
  // Manually manage the state of the UITooltip to close when the dropdown opens
  const [openTooltip, setOpenTooltip] = useState(undefined);
  const onDropdownOpenChange = dropdownOpenChangeEvent => {
    if (dropdownOpenChangeEvent.target.value) {
      setOpenTooltip(false);
    } else {
      // Set openTooltip back to undefined instead of true because undefined gives control back to the UITooltip
      setOpenTooltip(undefined);
    }
  };
  const trackOpen = () => {
    usageTracker.track('view-message-actions', {
      action: 'view message actions',
      channel: getUsageTrackingChannel(genericChannelId)
    });
  };
  const renderDropdownButton = useCallback(({
    onClick
  }) => {
    return /*#__PURE__*/_jsx(MessageActionsButton, {
      onClick: onClick,
      buttonIcon: VerticalMenuIcon,
      tooltipProps: {
        title: I18n.text('conversations-inbox-message-history.common-message.messageActions'),
        open: openTooltip
      }
    });
  }, [openTooltip]);
  return /*#__PURE__*/_jsx(Tooltip, {
    title: I18n.text('conversations-inbox-message-history.common-message.messageActions'),
    open: openTooltip,
    children: /*#__PURE__*/_jsx(Dropdown, {
      buttonUse: "transparent",
      Button: renderDropdownButton,
      minMenuWidth: 125,
      caretRenderer: null,
      placement: 'bottom left',
      arrowSize: 'none',
      animateOnToggle: true,
      "data-test-id": "message-actions-dropdown",
      onOpenChange: onDropdownOpenChange,
      onOpenComplete: trackOpen,
      role: 'menu',
      children: /*#__PURE__*/_jsx(List, {
        wrapChildren: true,
        children: children
      })
    })
  });
};
MessageActionsDropdown.displayName = 'MessageActionsDropdown';
export default MessageActionsDropdown;